import { render, staticRenderFns } from "./PaymentPage.vue?vue&type=template&id=45a8c1a8&scoped=true&"
import script from "./PaymentPage.vue?vue&type=script&lang=js&"
export * from "./PaymentPage.vue?vue&type=script&lang=js&"
import style0 from "./PaymentPage.vue?vue&type=style&index=0&id=45a8c1a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a8c1a8",
  null
  
)

export default component.exports